<script>
import DeepClone from 'lodash/cloneDeep'
import { assetMovementTypeOptions } from '@modules/asset-management/helpers/option-map'
import _baseDropdownPicker from '../_base-dropdown-picker.vue'

export default {
  name: 'AssetMovementTypePicker',
  extends: _baseDropdownPicker,
  data() {
    this.unassignedValue = null
    return {}
  },
  computed: {
    options() {
      return DeepClone(assetMovementTypeOptions())
    },
  },
}
</script>
